/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
} from "../apiHandler";
import { isEmptyObj } from "../../utils/helper";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 5;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, params, endPoint });

export default class User {
  static getRole(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/roles`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.getRole.cancel = request.cancel;
    return request;
  }

  static updateRoles(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/roles/${memberId}/authorizations`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.updateRoles.cancel = request.cancel;
    return request;
  }

  static resetPassword(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/resetPasswordByAdmin`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.resetPassword.cancel = request.cancel;
    return request;
  }

  static AddSubscription(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/subscriptions`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.AddSubscription.cancel = request.cancel;
    return request;
  }

  static ImpersonateOtherUser(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/impersonate`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.ImpersonateOtherUser.cancel = request.cancel;
    return request;
  }

  static InitiateImpersonate(data, memberId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/members/${memberId}/initiateImpersonate`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.InitiateImpersonate.cancel = request.cancel;
    return request;
  }

  static addVenue(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/venues`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.addVenue.cancel = request.cancel;
    return request;
  }

  static getActiveVenues(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/venues/active`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.getActiveVenues.cancel = request.cancel;
    return request;
  }

  static getAllConfigIp(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/userConfigIp/getAllIpList`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.getAllConfigIp.cancel = request.cancel;
    return request;
  }

  static handleToggleStatus({ id, isActive }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/userConfigIp/${id}/status`, {
      accessToken: accessTokenFromLocal,
      params: { isActive },
      data: {},
    });

    User.handleToggleStatus.cancel = request.cancel;
    return request;
  }

  static updateMemberIp(id, data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/userConfigIp/${id}`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.updateMemberIp.cancel = request.cancel;
    return request;
  }

  static addMemberIp(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/userConfigIp`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    User.addMemberIp.cancel = request.cancel;
    return request;
  }

  static markAttendance(token) {
    const request = get(`/api/mark-attendance`, {
      params: { token },
      data: {},
    });

    User.markAttendance.cancel = request.cancel;
    return request;
  }
}
